import { useEffect, useState } from 'react'

import { FetchingConfigError } from '../../../../trillion-common/src/API/errors/FetchingConfigError'
import { getJewelryPath } from '../../../../trillion-common/src/API/storageAPI'
import { JewelryTypeName } from '../../../../trillion-common/src/typings/jewelry-type'
import { NoBillingPackageError } from '../../../../trillion-common/src/API/errors/NoBillingPackageError'
import { TrillionBackend } from '../../../../trillion-common/src/API/trillion-backend'
import { useAppStore } from '../../shared/store/store'
import { ViewerAppError } from '../errors/viewer-app-error'
import { WidgetConfig } from '../../../../trillion-common/src/objects/widget-config.object'
import { IncorrectActivationKeyError } from '../../../../trillion-common/src/API/errors/IncorrectActivationKeyError'

export function useWidgetConfig(sku: string, defaultJewelryType: JewelryTypeName) {
  const widgetConfig = useAppStore((state) => state.widgetConfig)
  const setWidgetConfig = useAppStore((state) => state.setWidgetConfig)
  const [configError, setConfigError] = useState<Error | null>(null)

  useEffect(() => {
    async function load() {
      const configDto = new WidgetConfig(await TrillionBackend.getProductConfigForWidget(sku))

      if (!configDto.modelPath || configDto.modelPath === '')
        configDto.modelPath = getJewelryPath(sku)

      return configDto
    }

    setWidgetConfig(undefined)

    load()
      .then((config) => {
        setWidgetConfig(config)
      })
      .catch((error) => {
        console.log(error)

        if (
          error instanceof NoBillingPackageError ||
          error instanceof IncorrectActivationKeyError
        ) {
          setConfigError(error)
        }

        if (error instanceof FetchingConfigError) {
          setWidgetConfig(
            new WidgetConfig({
              modelPath: getJewelryPath(sku),
              category: defaultJewelryType,
              sku: sku,
              buyItNowEnabled: false,
              linkToProduct: '',
              carat: undefined,
              widgetReflectionMap: undefined,
              ringPositionHeight: undefined,
              revertDirection: false,
            }),
          )
        }
      })
  }, [sku])

  useEffect(() => {
    // handle async errors to help ErrorBoundary catch them
    if (configError instanceof NoBillingPackageError) {
      throw new ViewerAppError(
        'Problem with the license, please contact the administration',
        configError,
      )
    } else if (configError instanceof IncorrectActivationKeyError) {
      throw new ViewerAppError(
        'Problem with the activation key, please contact the administration',
        configError,
      )
    }
  }, [configError])

  return widgetConfig
}
